// extracted by mini-css-extract-plugin
export default {"container":"PolicyViewer_container__LEPu-","submit":"PolicyViewer_submit__QX3Dk","logo":"PolicyViewer_logo__PwMUO","markdownContainer":"PolicyViewer_markdownContainer__x8lmL"};